<!-- message-read-modal.component.html -->
<div class="msg-modal">
  <header class="msg-header">
    <div class="heading">
      <h2 class="title" mat-dialog-title>{{ data.title }}</h2>
      <p class="subtitle" *ngIf="subtitle">{{ data.subtitle }}</p>
    </div>

    <!-- Reply chip  | safeHtml-->
    <mat-chip-listbox class="reply-chip" *ngIf="!showReply">
      <mat-chip-option selected="false" (click)="showReply = true">
        <mat-icon>reply</mat-icon>
        Responder
      </mat-chip-option>
    </mat-chip-listbox>
  </header>

  <mat-divider></mat-divider>

  <mat-dialog-content class="msg-content">
    <div class="message" [innerHTML]="data.Mmessage"></div>

    <!-- Reply box -->
    <section class="reply-wrap" *ngIf="showReply">
      <div class="reply-head">
        <mat-icon>reply</mat-icon>
        <span>Tu respuesta</span>
      </div>

      <mat-form-field appearance="outline" class="reply-field">
        <mat-label>Escribe tu comentario</mat-label>
        <textarea
          matInput
          [(ngModel)]="replyText"
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          cdkAutosizeMaxRows="8"
          placeholder="Añade contexto, instrucciones o un comentario…">
        </textarea>
        <button mat-icon-button matSuffix *ngIf="replyText" (click)="replyText=''" aria-label="Limpiar">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="msg-actions">
    <button mat-stroked-button color="primary" class="cancelar" (click)="onClose()">
      Cerrar
    </button>

    <button mat-flat-button color="primary"  class="aceptar" (click)="onAcknowledge()">
      <mat-icon>check_circle</mat-icon>
      Aceptar
    </button>

    <button  class="enviar"
      mat-flat-button
      color="accent"
      *ngIf="showReply"
      [disabled]="!replyText?.trim()"
      (click)="responder()">
      <mat-icon>send</mat-icon>
      Enviar
    </button>
  </mat-dialog-actions>
</div>
